/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateResult } from '../../models/create-result';
import { UpdateTestCommand } from '../../models/update-test-command';

export interface ApiTestsPut$Params {

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
      body?: UpdateTestCommand
}

export function apiTestsPut(http: HttpClient, rootUrl: string, params?: ApiTestsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
  const rb = new RequestBuilder(rootUrl, apiTestsPut.PATH, 'put');
  if (params) {
    rb.header('x-space-id', params['x-space-id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateResult>;
    })
  );
}

apiTestsPut.PATH = '/api/Tests';
